import { NgIf } from '@angular/common';
import { Component, computed, inject, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ProjectInfrastructureService } from '@app/shared/services/project-infrastructure.service';
import { PublicCommittee } from 'lfx-pcc';
import { SelectItemGroup } from 'primeng/api';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'lfx-committee-filter',
  standalone: true,
  imports: [SelectModule, FormsModule, NgIf],
  templateUrl: './committee-filter.component.html',
  styleUrl: './committee-filter.component.scss',
})
export class CommitteeFilterComponent implements OnInit {
  public committees: WritableSignal<PublicCommittee[]> = signal([]);
  public selectedCommittee: WritableSignal<PublicCommittee> = signal({} as PublicCommittee);
  public groupedCommittees: Signal<SelectItemGroup[]> = computed(() => this.groupCommittees(this.committees()));

  private itxService: ProjectInfrastructureService = inject(ProjectInfrastructureService);
  private router: Router = inject(Router);

  public ngOnInit(): void {
    this.committees = this.itxService.committees;
    this.selectedCommittee = this.itxService.selectedCommittee;
  }

  public onCommitteeChange(event: any): void {
    const committee = event.value;
    this.itxService.selectedCommittee.set(committee);
    this.router.navigate([], { queryParams: { committee: committee.ID }, queryParamsHandling: 'merge' });
  }

  public onCommitteeClear(): void {
    this.selectedCommittee.set({} as PublicCommittee);
    this.router.navigate([], { queryParams: { committee: null }, queryParamsHandling: 'merge' });
  }

  private groupCommittees(committees: PublicCommittee[]): SelectItemGroup[] {
    // Each committee has a ProjectID, so we can group by project
    const projects = new Map<string, SelectItemGroup>();

    committees.forEach((committee) => {
      if (!projects.has(committee.ProjectID)) {
        projects.set(committee.ProjectID, { label: committee.ProjectName, items: [] });
      }

      projects.get(committee.ProjectID)?.items.push({ label: committee.Name, value: committee });
    });

    return Array.from(projects.values());
  }
}
